import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import pwsLogo from "../../../assets/logo800.webp";
import ImageWithSkeleton from "../../../components/ui/ImageWithSkeleton";
import "./ForgotPassword.css";

export default function ForgotPassword() {
  const { t } = useTranslation('forgotPassword');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/password-reset`, {
        email,
        continueUrl: window.location.origin + '/login',
      });
      setMessage(t('resetLinkSent'));
    } catch (error) {
      const code = error.response?.data?.code;
      let errorMessage = '';
      switch (code) {
        case 'user_not_found':
          errorMessage = t('userNotFound');
          break;
        case 'validation_failed':
          errorMessage = t('invalidEmail');
          break;
        default:
          errorMessage = error.response?.status === 429
            ? t('tooManyRequests')
            : t('genericError');
      }
      setError(errorMessage);
    }

    setLoading(false);
  };

  return (
    <div className="login-wrapper">
      <div className="login-content">
        <div className="login-card">
          <form className="login-form-new" onSubmit={handleSubmit}>
            <div className="login-form-header">
              <div className="login-logo-wrap">
                <ImageWithSkeleton
                  src={pwsLogo}
                  alt="PLAYWORLD"
                  loading="eager"
                  imgStyle={{ width: "100%", height: "auto", display: "block" }}
                  style={{ width: "100%", zIndex: 2, position: "relative" }}
                />
              </div>
              <div className="login-card-title">{t('resetPasswordTitle')}</div>
              <div className="login-card-subtitle">{t('resetPasswordSubtitle')}</div>
            </div>

            {message && (
              <div className="login-message-success">
                {message}
                <p style={{ marginTop: '6px', fontSize: '12px', fontStyle: 'italic' }}>{t('checkSpamNotice')}</p>
              </div>
            )}

            {error && (
              <div className="login-error-message">{error}</div>
            )}

            <div className="login-field">
              <label>{t('email')}</label>
              <input
                type="email"
                placeholder={t('emailPlaceholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button className="login-btn-submit" type="submit" disabled={loading}>
              {loading ? t('sending') : t('sendResetLink')}
            </button>

            <div className="login-forgot-row">
              <button type="button" className="login-forgot-link" onClick={() => navigate('/login')}>
                {t('backToLogin')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}